// Pulse periods are stored as 'YYYY-MM' (UTC-based).
// The cron runs on the 1st of each month and collects the PREVIOUS month
// (e.g., on June 1, we ask directors for the May pulse → period = '2026-05').

export function formatPeriod(date: Date): string {
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  return `${year}-${month}`
}

export function previousMonth(now: Date = new Date()): string {
  const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 1))
  return formatPeriod(d)
}

export function currentMonth(now: Date = new Date()): string {
  return formatPeriod(now)
}

export const PERIOD_REGEX = /^\d{4}-\d{2}$/

// Formats a 'YYYY-MM' period as French long form, e.g. '2026-04' → 'avril 2026'.
const FR_PERIOD = new Intl.DateTimeFormat('fr-CA', {
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
})

export function formatPeriodLong(period: string): string {
  const match = PERIOD_REGEX.exec(period)
  if (!match) return period
  const [year, month] = period.split('-').map(Number)
  return FR_PERIOD.format(new Date(Date.UTC(year, month - 1, 1)))
}

// Date du jour 'YYYY-MM-DD' en heure de Toronto. Le dispatcher quotidien (cron
// Cloud Scheduler à 8h Toronto) compare les dates dans ce fuseau ; en-CA formate
// nativement en 'YYYY-MM-DD'.
const TORONTO_DATE = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/Toronto',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

export function todayDateString(now: Date = new Date()): string {
  return TORONTO_DATE.format(now)
}

// Jour du mois (1..31) en heure de Toronto.
export function dayOfMonth(dateStr: string): number {
  return Number(dateStr.split('-')[2])
}

// Décale une période 'YYYY-MM' de `delta` mois (négatif = passé).
export function shiftPeriod(period: string, delta: number): string {
  const [year, month] = period.split('-').map(Number)
  return formatPeriod(new Date(Date.UTC(year, month - 1 + delta, 1)))
}

// Retourne `count` périodes consécutives se terminant à `period` (inclus),
// du plus ancien au plus récent. Utile pour les mini-tendances.
export function periodsEndingAt(period: string, count: number): string[] {
  return Array.from({ length: count }, (_, i) =>
    shiftPeriod(period, i - (count - 1)),
  )
}
